import React, { useEffect, useState } from "react";
import CardLoading from "../../../../../../components/CardLoading";
import { fetchData } from "../../../../../../features/dropdown/dropdownSlice";
import { Checkbox, Divider, Dropdown, Table, Tag } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Search from "../../../../../../components/Search";
import svg77 from "../../../../../../assets/svg/svg77.svg";
import svg102 from "../../../../../../assets/svg/svg102.svg";
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import { formatText, normalizeDateToLocalYear } from "../../../../../../utils";
import ProfileView from "../../../../jobs/recommendation/ProfileView";
import { setRowId } from "../../../../../../features/folder/folderSlice";

function Candidates({ prodd, openDrawer }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v1/applications/filter";
  const { loading, data, count, activeObjActivity } = useSelector((state) => ({
    loading: state.dropdown.loading,
    data: state.dropdown.data[url] || [],
    count: state.dropdown.count[url] || 0,
    activeObjActivity: state.folder.activeObj["activity"],
  }));

  const { rowId, selectedCandidates } = useSelector((state) => state.folder);

  const { open, handleCancel, handleOpen } = useModalToggle();
  const { refetchKey } = useSelector((state) => state.folder);

  const showDrawer = () => {
    handleOpen();
  };
  const onClose = () => {
    handleCancel();
  };

  const [searchInput, setsearchInput] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        damName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const statusMap = {
    Submitted: { value: "DRAFT", label: "Submitted" },
    Shortlisted: { value: "SHORTLIST", label: "Shortlisted" },
    Scheduled_Interview: {
      value: "SCHEDULE_INTERVIEW",
      label: "Scheduled_Interview",
    },
  };

  const plainOptions = Object?.values(statusMap)?.map(({ value, label }) => ({
    value,
    label,
  }));

  const [selectedFilters, setSelectedFilters] = useState([]);
  const [popoverVisible, setPopoverVisible] = useState(false);

  const handleRemoveFilter = (removedStatus) => (e) => {
    e.preventDefault();
    setSelectedFilters((prev) =>
      prev?.filter((status) => status !== removedStatus)
    );
  };
  const onChangeFilter = (checkedValues) => {
    setSelectedFilters(checkedValues);
  };

  const handleApply = async () => {
    await setPopoverVisible(false);
  };

  const handleReset = async () => {
    await setSelectedFilters([]);
    await setPopoverVisible(false);
  };
  const filterOverlay = (
    <div className="w-[15.6875rem] p-[1.5rem] bg-white rounded-[.5rem] shadow-[0_0_13.9px_0_rgba(0,0,0,0.08)]">
      <p className="font-semibold">Select Filter</p>
      <Checkbox.Group
        options={plainOptions}
        value={selectedFilters}
        onChange={onChangeFilter}
        className="filter-checkbox"
      />

      <Divider />

      <div className="flex justify-center gap-[1.5rem] mt-3 font-dmSans text-[.875rem] font-[400]">
        <span className="text-[#FDB505]  cursor-pointer" onClick={handleReset}>
          Reset
        </span>
        <span className="text-[#C62130]  cursor-pointer" onClick={handleApply}>
          Apply
        </span>
      </div>
    </div>
  );

  const [prodd1, setProdd1] = useState();
  const handleViewName = async (item) => {
    await setProdd1(item);
    await showDrawer();
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "5%",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Candidate",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.japFirstName} {item?.japLastName}
          </div>
        );
      },
    },
    {
      title: "japId",
      dataIndex: "japId",
    },
    {
      title: "Match Score",
      dataIndex: "japMatchingScore",
      render: (item) => {
        return (
          <div className="py-[.25rem] px-[.5rem] flex items-center justify-center gap-[.625rem] rounded-[.25rem] bg-[#569D6E] opacity-[0.8]">
            {item}
          </div>
        );
      },
    },
    {
      title: "Progress Status",
      dataIndex: "japProgressStatus",
      render: (item) => {
        const colors = {
          DRAFT: "#706F6F",
          SHORTLIST: "#FDB505",
          SCHEDULE_INTERVIEW: "#DAA520",
          OFFER: "#569D6E",
          HIRE: "#569D6E",
          DROP: "#C62130",
        };

        return (
          <div
            className="bg-[#E8EEED] inline-block rounded-[8px] px-[1rem] py-[.25rem] w-auto !font-[500] !text-[1rem]"
            style={{
              color: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
  ];

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedAppplicants, setSelectedApplicants] = useState([]);

  const handleSelected = async () => {
    const updatedApplicants = selectedAppplicants?.map((applicant) => ({
      ...applicant,
      japInterviewStartTime: prodd.mbiStartTime,
      japInterviewEndTime: prodd.mbiEndTime,
      japInterviewSession: prodd?.mbiName,
      japJaaId: activeObjActivity?.jaaId,
      japInterviewDate: normalizeDateToLocalYear(
        activeObjActivity?.jaaStartDate
      ),
    }));

    await dispatch(setRowId([...(rowId || []), ...(updatedApplicants || [])]));
 await fetchTableData(null, null, [...(rowId || []), ...(updatedApplicants || [])]);
    await setSelectedRowKeys([]);
    await setSelectedApplicants([]);
  };

  const onSelectChange = (keys, rows) => {
    setSelectedRowKeys(keys);
    setSelectedApplicants(rows);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
 
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  async function fetchTableData(page, size,customRowId) { 
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
        jobId: activeObjActivity?.jaaJobId,
        progressStatuses: selectedFilters,
       japIds:
        selectedCandidates?.length > 0
          ? selectedCandidates?.map((item) => item?.japId)
          : (customRowId || rowId)?.map((item) => item?.japId),
      })
    );
  }

  useEffect(() => {
    if (openDrawer) {
      fetchTableData();
    }
  }, [selectedFilters, openDrawer]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <>
      <div className="flex items-center text-[#706F6F] text-[.875rem] font-dmSans font-[400] mt-[1.5rem] gap-[.5rem]">
        <img src={svg102} alt="svg102" />
        Candidates pending. Select to add to session
      </div>
      <div className="flex lg:flex-row flex-col lg:items-center justify-between mt-[1rem]">
        <div className="flex items-center gap-[1rem]">
          <div className="lg:w-[35.125rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>

          <Dropdown
            overlay={filterOverlay}
            trigger={["click"]}
            placement="bottom"
            open={popoverVisible}
            onOpenChange={(visible) => setPopoverVisible(visible)}
          >
            <div className="flex items-center cursor-pointer text-[#706F6F] text-[.875rem] font-[400] font-dmSans">
              <span>Filter</span>
              <img src={svg77} alt="filter icon" className="ml-1" />
            </div>
          </Dropdown>
        </div>

        {selectedAppplicants?.length > 0 && (
          <div className="w-[150px]">
            <button
              className="cstm-btn-2"
              type="button"
              onClick={handleSelected}
            >
              Add Selected
            </button>
          </div>
        )}
      </div>
      <div className="mt-[1.25rem]">
        {selectedFilters &&
          selectedFilters?.map((status) => {
            const matchedOption = plainOptions?.find(
              (opt) => opt?.value === status
            );
            const label = matchedOption ? matchedOption.label : status;

            const statusColors = {
              Submitted: "#706F6F",
              Shortlisted: "#FDB505",
              Scheduled_Interview: "#DAA520",
              Offer: "#569D6E",
              Hired: "#569D6E",
              Dropped: "#C62130",
            };

            return (
              <Tag
                closeIcon
                onClose={handleRemoveFilter(status)}
                className="inline-block w-fit max-w-max px-[.5rem] py-[.25rem] bg-[#E8EEED]
                        rounded-[2.1875rem] text-[.75rem] font-[400]"
                style={{ color: statusColors[label] || "#000" }}
              >
                {label}
              </Tag>
            );
          })}
      </div>

      <Table
        rowSelection={rowSelection}
        className="mt-[1.5rem] w-full"
        scroll={{
          x: "auto",
        }}
        rowKey={(record) => record?.japId}
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{
          position: ["bottomRight"],
          current: pageIndex + 1,
          total: count,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPageIndex(page - 1);
            setPageSize(size);
            fetchTableData(page - 1, size);
          },
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />

      <ProfileView
        onClose={onClose}
        openDrawer={open}
        prodd={prodd1}
        action={false}
      />
    </>
  );
}

export default Candidates;
